import Decimal from 'decimal.js';

export interface OrderBookItem {
  price: Decimal;
  size: Decimal;
}

export interface OrderBookData {
  asks: OrderBookItem[];
  bids: OrderBookItem[];
  marketId: string;
}

export enum EOrderBookSide {
  ASKS = 'asks',
  BIDS = 'bids',
}

export type OrderBookSide = `${EOrderBookSide}`;
